import Text from 'components/shared/Typography/Text';

import s from '../MagicImportStatusModal.module.css';

type SlideSceneProps = {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
  linkText: string;
  linkHref: string;
};

export const SlideScene = ({ imageSrc, imageAlt, title, description, linkText, linkHref }: SlideSceneProps) => {
  return (
    <div>
      <div className={s.slide}>
        <div className={s.slideImageWrapper}>
          <img src={imageSrc} alt={imageAlt} className={s.slideImage} />
        </div>
        <div className={s.cardWrapper}>
          <Text type="brandon" className={s.cardTitle}>
            {title}
          </Text>
          <Text type="brandon" size="medium" className={s.cardDescription}>
            {description}{' '}
            <a className={s.learnMoreLink} target="_blank" rel="noopener noreferrer" href={linkHref}>
              {linkText}
            </a>
          </Text>
        </div>
      </div>
    </div>
  );
};
